import { DecimalPipe } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CatalogService, RentalAgreement } from './catalog.service';

@Component({
  standalone: true,
  selector: 'ain-rental-agreements',
  imports: [DecimalPipe, AinPageComponent, AinStateComponent, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('catalog.rental.agreements.title')" [description]="t('catalog.rental.agreements.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('catalog.loading')" />
      } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('catalog.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('catalog.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <p-table [value]="rows()" [paginator]="true" [rows]="15">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"><input type="checkbox" aria-label="select all" /></th>
                <th>{{ t('catalog.rental.agreementNumber') }}</th>
                <th>{{ t('catalog.service.customerReference') }}</th>
                <th>{{ t('catalog.tracking.status') }}</th>
                <th>{{ t('catalog.rental.depositAmount') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><input type="checkbox" [attr.aria-label]="row.agreementNumber" /></td>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.agreementNumber }}</button></td>
                <td>{{ row.customerReference }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.depositAmount | number:'1.2-2' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`
    .panel { display: grid; gap: 10px; }
    .toolbar { display: flex; gap: 8px; }
    .link-btn { border: 0; background: none; color: #1d4ed8; cursor: pointer; font-weight: 600; padding: 0; }
  `]
})
export class RentalAgreementsComponent implements OnInit {
  private readonly service = inject(CatalogService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);

  readonly loading = signal(true);
  readonly rows = signal<RentalAgreement[]>([]);

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading.set(true);
    this.service.listRentalAgreements().subscribe({
      next: rows => { this.rows.set(rows); this.loading.set(false); },
      error: () => { this.rows.set([]); this.loading.set(false); }
    });
  }

  openDetail(id: string): void { void this.router.navigate(['/rental/agreements', id]); }
  openCreate(): void { void this.router.navigate(['/rental/agreements', 'new']); }

  t(key: string): string { return this.localization.translate(key); }
}
